export interface Option<T> {
	value: T;
	text: string;
	style?: string;
	legendaClass?: string;
}

// Interface en class delen bewust de naam: de interface beschrijft ook object-literals.
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
export class Option<T> {
	constructor(
		public value: T,
		public text: string = `${value}`,
		public style?: string,
		public legendaClass?: string
	) {}
}

export const DEFAULT_EMPTY_STATE = 'Geen resultaten';
